import { useEffect } from "react";

import { GrowthBookProvider } from "@growthbook/growthbook-react";

import growthbook from "@/utils/growthbook";

export default function GrowthbookLayout({ children }) {
  useEffect(() => {
    // Load features asynchronously when the app renders
    growthbook.init({ streaming: true });
  }, []);

  return <GrowthBookProvider growthbook={growthbook}>{children}</GrowthBookProvider>;
}
